import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'FabricFormat', pure: true})
export class FabricFormatPipe implements PipeTransform {
  transform(fabric: any): string {
    if (!fabric) { return ''; }
    const collection = this.toObj(fabric.fabricCollection);
    const parts = [collection?.name, ...this.getDetailParts(fabric, collection)];
    return parts.filter(Boolean).join(', ');
  }

  private getDetailParts(fabric: any, collection: any): string[] {
    if (collection?.isCustom) {
      return [fabric.fabricName, fabric.fabricColorName];
    }
    return [this.toObj(fabric.fabric)?.name, this.toObj(fabric.fabricColor)?.name];
  }

  private toObj(v: any): any {
    return v && typeof v === 'object' ? v : null;
  }
}
